'use strict';

angular
  .module('wyndowApp', [
    'ngAnimate',
    'ngCookies',
    'ngResource',
    'ngRoute',
    'ngSanitize',
    'ngTouch'
  ]).config(function($interpolateProvider){
    console.log('heeeeey!');
    $interpolateProvider.startSymbol('{[{').endSymbol('}]}');
});
'use strict';

angular.module('wyndowApp')
  .controller('ConfiguratorCtrl', function ($scope, $http, $window, $timeout) {

    $scope.normalWyndow = true;
    $scope.assets = $window.wyndow.assets;
    $scope.wyndowImages = $window.wyndow.images;
    $scope.smallWyndowImages = $window.wyndow.small_images;
    console.log("wyndowImages ");
    console.log($scope.wyndowImages);
    $scope.currentColor = "black";
    $scope.imagesIndex = 1;
    $scope.currentWyndow = $scope.wyndowImages[$scope.currentColor][$scope.imagesIndex];
    console.log($scope.currentWyndow);
    $scope.firstMsg = 'Your';
    $scope.msg = 'Text';
    $scope.lastMsg = 'Here';
    $scope.s_firstMsg = "Your";
    $scope.s_lastMsg = "Text";
    $scope.isSafari = $window.safari;

    $scope.wyndowColor = "black";
    $scope.font = 'e-max';
    $scope.wyndowFont = "Jane Doe";
    $scope.message = $scope.firstMsg+' '+$scope.msg+' '+$scope.lastMsg;
    $scope.light = false;
    $scope.currentWyndowSize = "normal";
    $scope.wyndowSize = "60 x 45 x 10 cm";
    $scope.loaded = false;
    $scope.lightStatus = 'off';
    $scope.cable = 'Schwarz';

    $scope.viewInputs = true;
    $scope.viewFonts = false;
    $scope.viewColors = false;

    $scope.fonts = {  
      'e-max': 'Jane Doe',
      'elementa-pro-italic': 'Slanted',
      'times-semi': 'Clarck',
      'stencil-allround': 'Stencil',
      'bingo': 'Brooklyn'
    };

    $scope.colors = {
      'black': 'Schwarz',
      'blue': 'Blau',
      'white': 'Weiß',
      'red': 'Rot',
      'silver': 'Silber',
      'yellow': 'Gelb' 
    };

    $scope.hideSections = function(){
      $scope.viewInputs = false;
      $scope.viewFonts = false;
      $scope.viewColors = false;
    }

    $scope.changeLight = function(light){
      if (light) {
        $scope.light = false;
        $scope.imagesIndex = 1;
        $scope.changeWyndow($scope.currentColor);
        $scope.lightStatus = 'off';
      }else{
        $scope.light = true;
        $scope.imagesIndex = 0;
        $scope.changeWyndow($scope.currentColor);
        $scope.lightStatus = 'on';
      }
    }

    $scope.changeWyndowSize = function(small){
      $scope.loaded = false;
      if (small) {
        $scope.normalWyndow = false;
        $scope.currentWyndowSize = "small";
        $scope.wyndowSize = '45 x 33,5 x 8 cm';
        $scope.s_firstMsg = "Your";
        $scope.s_lastMsg = "Text";
        $scope.changeProduct();
        $scope.changeWyndow($scope.wyndowColor);

      }else{
        $scope.normalWyndow = true;
        $scope.currentWyndowSize = "normal";
        $scope.wyndowSize = '60 x 45 x 10 cm';
        $scope.firstMsg = 'Your';
        $scope.msg = 'Text';
        $scope.lastMsg = 'Here';
        $scope.changeProduct();
        $scope.changeWyndow($scope.wyndowColor);
      }
    }

    $scope.changeCable = function(cableColor){
      $scope.cable = '';
      $scope.cable = cableColor;  
    }

    $scope.changeWyndow = function(color){
      console.log(color);
      console.log(color);
      $scope.currentColor = color;
      if ($scope.currentWyndowSize == 'normal') {
        $scope.currentWyndow = $scope.wyndowImages[$scope.currentColor][$scope.imagesIndex];    
        $scope.message = $scope.firstMsg+' '+$scope.msg+' '+$scope.lastMsg;
      }else{
        $scope.currentWyndow = $scope.smallWyndowImages[$scope.currentColor][$scope.imagesIndex];
        $scope.message = $scope.s_firstMsg+' '+$scope.s_lastMsg;
      }
      $scope.wyndowColor = color;
      console.log($scope.currentWyndow);
      $scope.loaded = true;
    }
    $scope.changeWyndowFont = function(fontName){
      $scope.font = fontName;
      $scope.wyndowFont = $scope.fonts[fontName];
      console.log('Font: '+$scope.fonts[fontName]);
    }

  $scope.$watch('currentWyndow', function(newValue, oldValue) {
    console.log('newValue:');
    console.log(newValue);
    console.log('oldValue: ');
    console.log(oldValue);
  });

    $scope.changePrice = function(input){
      if ($scope.currentWyndowSize === 'normal') {
        if (($scope.firstMsg != "" && typeof $scope.firstMsg != "undefined")
        && ($scope.msg == "" || typeof $scope.msg == "undefined")
        && ($scope.lastMsg == "" || typeof $scope.lastMsg == "undefined")) {
          console.log('Wyndow Message is: '+$scope.firstMsg+' '+$scope.msg+' '+$scope.lastMsg+' and price is 3000');
        $scope.message = $scope.firstMsg+' '+$scope.msg+' '+$scope.lastMsg;
          $scope.price = $scope.product.variants[0].price;
          $scope.variantId = $scope.product.variants[0].id;
          $scope.variantId = $scope.variantId.toString();
        }else if (($scope.firstMsg == "" || typeof $scope.firstMsg == "undefined")
        && ($scope.msg != "" && typeof $scope.msg != "undefined")
        && ($scope.lastMsg == "" || typeof $scope.lastMsg == "undefined")) {
          console.log('Wyndow Message is: '+$scope.firstMsg+' '+$scope.msg+' '+$scope.lastMsg+' and price is 3000');
          $scope.message = $scope.firstMsg+' '+$scope.msg+' '+$scope.lastMsg;
          $scope.price = $scope.product.variants[0].price;
          $scope.variantId = $scope.product.variants[0].id;
          $scope.variantId = $scope.variantId.toString();
        }else if (($scope.firstMsg != "" || typeof $scope.firstMsg != "undefined")
        && ($scope.msg != "" && typeof $scope.msg != "undefined")
        && ($scope.lastMsg == "" || typeof $scope.lastMsg == "undefined") ||
        (($scope.firstMsg == "" || typeof $scope.firstMsg == "undefined")
        && ($scope.msg != "" && typeof $scope.msg != "undefined")
        && ($scope.lastMsg != "" && typeof $scope.lastMsg != "undefined"))) {
          console.log('Wyndow Message is: '+$scope.firstMsg+' '+$scope.msg+' '+$scope.lastMsg+' and price is 3500');
          $scope.message = $scope.firstMsg+' '+$scope.msg+' '+$scope.lastMsg;
          $scope.price = $scope.product.variants[1].price;
          $scope.variantId = $scope.product.variants[1].id;
          $scope.variantId = $scope.variantId.toString();
        }
        else if (($scope.firstMsg == "" || typeof $scope.firstMsg == "undefined")
        && ($scope.msg == "" || typeof $scope.msg == "undefined")
        && ($scope.lastMsg != "" && typeof $scope.lastMsg != "undefined")) {
          $scope.price = $scope.product.variants[0].price;
          $scope.variantId = $scope.product.variants[0].id;
          $scope.variantId = $scope.variantId.toString();
        }
       else if (($scope.firstMsg != "" && typeof $scope.firstMsg != "undefined")
        && ($scope.msg == "" || typeof $scope.msg == "undefined")
        && ($scope.lastMsg != "" && typeof $scope.lastMsg != "undefined") ||
        (($scope.firstMsg == "" || typeof $scope.firstMsg == "undefined")
        && ($scope.msg != "" && typeof $scope.msg != "undefined")
        && ($scope.lastMsg != "" && typeof $scope.lastMsg != "undefined"))) {
          console.log('Wyndow Message is: '+$scope.firstMsg+' '+$scope.msg+' '+$scope.lastMsg+' and price is 3500');
        $scope.message = $scope.firstMsg+' '+$scope.msg+' '+$scope.lastMsg;
          $scope.price = $scope.product.variants[1].price;
          $scope.variantId = $scope.product.variants[1].id;
          $scope.variantId = $scope.variantId.toString();
        }else if(($scope.firstMsg != "" && typeof $scope.firstMsg != "undefined")
        && ($scope.msg != "" && typeof $scope.msg != "undefined")
        && ($scope.lastMsg != "" && typeof $scope.lastMsg != "undefined")){
          console.log('Wyndow Message is: '+$scope.firstMsg+' '+$scope.msg+' '+$scope.lastMsg+' and price is 4000');
          $scope.message = $scope.firstMsg+' '+$scope.msg+' '+$scope.lastMsg;
          $scope.price = $scope.product.variants[2].price;
          $scope.variantId = $scope.product.variants[2].id;
          $scope.variantId = $scope.variantId.toString();
        }
      }else if ($scope.currentWyndowSize === 'small') {
        if (($scope.s_firstMsg != "" && typeof $scope.s_firstMsg != "undefined")
        && ($scope.s_lastMsg == "" || typeof $scope.s_lastMsg == "undefined")) {
          console.log('Wyndow Message is: '+$scope.s_firstMsg+' '+$scope.s_lastMsg+' and price is'+$scope.product.variants[0].price);
        $scope.message = $scope.s_firstMsg+' '+$scope.s_lastMsg;
          $scope.price = $scope.product.variants[0].price;
          $scope.variantId = $scope.product.variants[0].id;
          $scope.variantId = $scope.variantId.toString();
        }else if (($scope.s_firstMsg == "" || typeof $scope.s_firstMsg == "undefined")
        && ($scope.s_lastMsg != "" && typeof $scope.s_lastMsg != "undefined")) {
          console.log('Wyndow Message is: '+$scope.firstMsg+' '+$scope.msg+' '+$scope.lastMsg+' and price is'+$scope.product.variants[0].price);
          $scope.message = $scope.s_firstMsg+' '+$scope.s_lastMsg;
          $scope.price = $scope.product.variants[0].price;
          $scope.variantId = $scope.product.variants[0].id;
          $scope.variantId = $scope.variantId.toString();
        }else if (($scope.s_firstMsg != "" && typeof $scope.s_firstMsg != "undefined")
        && ($scope.s_lastMsg != "" && typeof $scope.s_lastMsg != "undefined"))
        {
          console.log('Wyndow Message is: '+$scope.firstMsg+' '+$scope.msg+' '+$scope.lastMsg+' and price is 3500');
          $scope.message = $scope.s_firstMsg+' '+$scope.s_lastMsg;
          $scope.price = $scope.product.variants[1].price;
          $scope.variantId = $scope.product.variants[1].id;
          $scope.variantId = $scope.variantId.toString();
        }
      }
    }

    $scope.changeProduct = function(){
      if ($scope.currentWyndowSize === 'normal') {
        var promise = $http.get('/products/wyndow-configurator.json');
        promise.then(function(responseData){
          console.log("Loading Data...");
          console.log(responseData.data.product);
          $scope.product = responseData.data.product;
          $scope.price = $scope.product.variants[2].price;
          $scope.variantId = $scope.product.variants[2].id;
          $scope.variantId = $scope.variantId.toString();
        });
      }else if($scope.currentWyndowSize === 'small'){
        var request = $http.get('/products/small-wyndow.json');
        request.then(function(responseData){
          console.log("Loading Data...");
          console.log(responseData.data.product);
          $scope.product = responseData.data.product;
          $scope.price = $scope.product.variants[1].price;
          $scope.variantId = $scope.product.variants[1].id;
          $scope.variantId = $scope.variantId.toString();
        });
      }      
    }

    $scope.product_id = $scope.product;

    $scope.product = {};
    $timeout(function() {
      if ($scope.isSafari) {
        console.log("Safari brower");
      }
      var promise = $http.get('/products/wyndow-configurator.json');

      promise.then(function(responseData){
        console.log("Loading Data...");
        console.log(responseData.data.product);
        $scope.product = responseData.data.product;
        $scope.price = $scope.product.variants[2].price;
        $scope.variantId = $scope.product.variants[2].id;
        $scope.variantId = $scope.variantId.toString();
      });

    }, 300);

    $timeout(function() {
      $scope.loaded = true;

    }, 900);

  });
